import React, { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const StepButton = ({
  values = [],
  onChange,
  value,
  type = "number",
  step = 1,
  min,
  max,
  onIncrement,
  onDecrement,
  showValue = true,
}) => {
  const [index, setIndex] = useState(0);

  const handleStep = (direction) => {
    if (type === "number") {
      let newValue = (value ?? 0) + direction * step;
      if (typeof min === "number") newValue = Math.max(newValue, min);
      if (typeof max === "number") newValue = Math.min(newValue, max);
      onChange && onChange(newValue);
    } else {
      const currentIdx = values.indexOf(value);
      const newIndex =
        currentIdx === -1
          ? 0
          : (currentIdx + direction + values.length) % values.length;
      setIndex(newIndex);
      onChange && onChange(values[newIndex]);
    }
  };

  const isVertical = false;
  let containerClass = isVertical ? "flex flex-col-reverse" : "flex flex-row";
  let minusClass = isVertical
    ? "rounded-t-none rounded-b-md"
    : "rounded-r-none rounded-l-md";
  let plusClass = isVertical
    ? "rounded-b-none rounded-t-md"
    : "rounded-l-none rounded-r-md";
  let verySmallClass =
    "p-0 h-4 w-4 flex items-center justify-center text-xs bg-gray-200 hover:bg-gray-300 transition-colors";

  if (value && showValue) {
    containerClass += " gap-2 items-center";
    minusClass = "rounded-full";
    plusClass = "rounded-full";
    verySmallClass =
      "p-0 h-7 w-7 flex items-center justify-center text-xs bg-gray-200 hover:bg-gray-300 transition-colors";
  }

  return (
    <div className={containerClass}>
      <button
        onClick={() => {
          onDecrement?.("-");
          handleStep(-1);
        }}
        className={`${minusClass} ${verySmallClass}`}
      >
        <LeftOutlined style={{ fontSize: "9px" }} />
      </button>
      {!!value && showValue && <div className="text-2xl">{value}</div>}
      <button
        onClick={() => {
          onIncrement?.("+");
          handleStep(1);
        }}
        className={`${plusClass} ${verySmallClass}`}
      >
        <RightOutlined style={{ fontSize: "9px" }} />
      </button>
    </div>
  );
};

export default StepButton;
